import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Layers, WalkOfShameLayers} from "../view/WalkOfShameLayers";
import {WalkOfShame} from "../WalkOfShame";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {TimelineLite} from "gsap";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";
import {WalkOfShameHelper} from "../../core/utils/WalkOfShameHelper";

export class FreespinOutro extends ContinueScreen {
    private readonly _animationBelow: PIXI.spine.Spine;
    private readonly _bg: PIXI.Sprite;
    private readonly _youWin: PIXI.Text;
    private readonly _played: PIXI.Text;
    private readonly _multiplier: PIXI.Text;
    private readonly _amount: PIXI.Text;
    private _soundName: string = "";

    constructor() {
        super(WalkOfShameLayers.getLayer(Layers.SCREENS)!);

        this._animationBelow = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("outro"));
        this._animationBelow.visible = false;
        this._animationBelow.position.set(360);

        this._bg = new PIXI.Sprite();
        this._bg.anchor.set(0.5);
        this._bg.position.set(360);

        const textStyleOthers: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#eef8ff",
                fontFamily: OpenSans.FAMILY,
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 30,
                stroke: "#047acc",
                strokeThickness: 8,
                lineJoin: "round"
            }),
            textStyleAmount: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#eef8ff",
                fontFamily: OpenSans.FAMILY,
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 150,
                stroke: "#047acc",
                strokeThickness: 16,
                lineJoin: "round"
            });

        this._youWin = new PIXI.Text("", textStyleOthers);
        this._youWin.anchor.set(0.5);
        this._youWin.position.set(360, 270);

        this._amount = new PIXI.Text("", textStyleAmount);
        this._amount.anchor.set(0.5);
        this._amount.position.set(360);

        this._played = new PIXI.Text("", textStyleOthers);
        this._played.anchor.set(0.5);
        this._played.position.set(360, 480);

        this._multiplier = new PIXI.Text("", textStyleOthers);
        this._multiplier.anchor.set(0.5);
        this._multiplier.position.set(360, 515);

        this.addChild(this._animationBelow, this._bg, this._youWin, this._played, this._multiplier, this._amount, this._continueButton);
    }

    public show(onContinueCallBack: () => void): void {
        const belowStakeWinRestriction: boolean = BelowStakeWinRestriction.isWinBelowStake(),
            tl: TimelineLite = new TimelineLite(),
            winNumber: string = WalkOfShame.apiPlugin.currency.formatValue(WalkOfShame.model.parsedGameData.totalWin),
            isNoWin: boolean = (winNumber === "0.00"),
            spinPlayed: number = WalkOfShame.model.parsedGameData.numberOfFreespinsPlayed;

        WalkOfShame.keypadPlugin.setWin(WalkOfShame.model.parsedGameData.totalWin, true, belowStakeWinRestriction);

        if (!belowStakeWinRestriction) {
            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.FS_END
            });

            this._soundName = (isNoWin ? WalkOfShameSound.FS_OUTRO_NO_WIN : WalkOfShameSound.FS_OUTRO_WIN);
            WalkOfShameSound.switchMusic({
                name: this._soundName,
                volume: 1
            });
        }

        if (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.FREESPIN) {
            this._bg.texture = WalkOfShame.assetLoader.getTextures("FS_SFS_intro/FS_outro")[0];
        } else {
            this._bg.texture = WalkOfShame.assetLoader.getTextures("FS_SFS_intro/SFS_outro")[0];

            // #125
            if (!belowStakeWinRestriction) {
                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.FS_END_SUPER
                });
            }
        }

        this._youWin.text = (belowStakeWinRestriction || isNoWin) ? "" : WalkOfShame.apiPlugin.translations.translate("TOTAL WIN");
        this._played.text = WalkOfShame.apiPlugin.translations.translate("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
        this._multiplier.text = WalkOfShame.apiPlugin.translations.translate("Multiplier:") + " " + WalkOfShame.model.parsedGameData.currentMultiplier;

        this._amount.style.fontSize = 150;
        this._amount.text = winNumber;
        WalkOfShameHelper.shrinkTextWidth(winNumber, this._amount, 650);

        super.show(onContinueCallBack);

        WalkOfShame.logo.turnOffAllParachutes();

        this._continueButton.visible = false;
        this._continueButton.enable(false);
        [this._bg, this._youWin, this._played, this._amount, this._multiplier].forEach((item: PIXI.DisplayObject) => {
            item.visible = true;
        });

        tl.add(() => {
            this._animationBelow.visible = true;
            this._animationBelow.updateTransform();
            this._animationBelow.state.clearTracks();
            this._animationBelow.state.setEmptyAnimation(0, 0);
        }, 0);
        tl.add(WalkOfShameHelper.createTimelineForAnimation(this._animationBelow, 0, "beneathIn", false), 0);

        tl.add(() => {
            this._continueButton.visible = true;
            this._continueButton.enable(true);

            this._animationBelow.state.clearTracks();
            this._animationBelow.state.setEmptyAnimation(0, 0);
            this._animationBelow.autoUpdate = true;
            this._animationBelow.state.setAnimation(0, "beneathLoop", true);
        });
    }

    protected close(): TimelineLite {
        // not calling super method in this case.

        const tl: TimelineLite = new TimelineLite,
            itemsArr: PIXI.DisplayObject[] = [this._bg, this._youWin, this._played, this._amount, this._multiplier, this._continueButton];
        tl.to(itemsArr, {
            duration: 0.6,
            alpha: 0
        }, 0);

        tl.add(() => {
            this._continueButton.enable(false);
            WalkOfShame.blackOverlay.hideOverlay(1);

            this._animationBelow.state.clearTracks();
            this._animationBelow.state.setEmptyAnimation(0, 0);
            this._animationBelow.state.setAnimation(0, "beneathOut", false);

            if (this._soundName) {
                WalkOfShameSound.switchMusic({
                    name: WalkOfShameSound.MAIN_GAME_MUSIC,
                    volume: 1
                }, undefined, {
                    name: "",
                    to: 0,
                    duration: 50
                });
            }
            this._soundName = "";

            BelowStakeWinRestriction.reset();

            WalkOfShame.multiplier.toggleMultiplier(false);
            WalkOfShame.multiplier.updateMultiplierText(1, false);

            WalkOfShame.updateMode(WalkOfShameGameMode.NORMAL, false);
        }, 0);

        tl.add(() => {
            this.visible = false;

            itemsArr.forEach((item: PIXI.DisplayObject) => {
                item.visible = false;
                item.alpha = 1;
            });

            this._animationBelow.visible = false;
            this._animationBelow.state.clearTracks();
        });

        return tl;
    }
}